import React from 'react';
import { Check, X, ArrowRight, Layers, Clock, BookOpen, TrendingUp, Shield, RefreshCw } from 'lucide-react';
import { motion } from 'framer-motion';
import { EdgePricing } from '../components/EdgePricing';
export function EdgeProduct() {
  return <div className="min-h-screen w-full bg-[#0A0F1C] text-slate-200 selection:bg-[#7FE0C3]/30 font-sans" data-id="element-858" data-mp="1r2kvejqrjni6">
      {/* 1. HERO */}
      <section className="relative pt-32 pb-20 px-6 md:px-12 max-w-7xl mx-auto text-center" data-id="element-859" data-mp="yfrspvttce5j">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-96 bg-slate-500/5 blur-[120px] rounded-full pointer-events-none" data-id="element-860" data-mp="uf7vytd5jcjx" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-861" data-mp="187np92g93w7n">
          <div className="inline-block px-3 py-1 rounded-full bg-slate-800 border border-slate-700 text-slate-400 text-xs font-bold uppercase tracking-widest mb-6" data-id="element-862" data-mp="aqyqxiqifc30">
            Recruiting Infrastructure
          </div>
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 tracking-tight" data-id="element-863" data-mp="2lum4p27qgkqd">
            HIRE Edge
          </h1>
          <p className="text-xl md:text-2xl text-slate-400 max-w-3xl mx-auto leading-relaxed" data-id="element-864" data-mp="2qmma3a6ko5uc">
            Predictable applicant flow for teams that want better candidates
            while keeping hiring, onboarding, and training internal.
          </p>
        </motion.div>
      </section>

      <EdgePricing data-id="element-865" data-mp="22xb49ead7l9c" />

      {/* 2. WHAT EDGE IS (AND ISN'T) */}
      <section className="py-20 px-6 md:px-12 max-w-5xl mx-auto border-t border-slate-800/50" data-id="element-866" data-mp="27vurdi0p333a">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-867" data-mp="2bwy9kb67tb7o">
          <div data-id="element-868" data-mp="2bv3l4mvqj0yu">
            <h3 className="text-lg font-bold text-white mb-6 flex items-center" data-id="element-869" data-mp="2buvbd3uwsbrv">
              <Check className="w-5 h-5 text-[#7FE0C3] mr-2" data-id="element-870" data-mp="3jcuk2eqyfjxu" />
              HIRE Edge is:
            </h3>
            <ul className="space-y-4" data-id="element-871" data-mp="3ne7qapxylp5a">
              {['A recruiting infrastructure layer', 'A predictable source of pre-screened applicants', 'A clean, managed top-of-funnel system'].map((item, idx) => <li key={idx} className="text-slate-300 flex items-start" data-id="element-872" data-mp="1x7rq4dxcz20f" data-mpi={idx}>
                  <span className="w-1.5 h-1.5 rounded-full bg-[#7FE0C3] mr-3 mt-2" data-id="element-873" data-mp="1sa9prbxepv41" />
                  {item}
                </li>)}
            </ul>
          </div>
          <div data-id="element-874" data-mp="10ikdxwimq596">
            <h3 className="text-lg font-bold text-white mb-6 flex items-center" data-id="element-875" data-mp="10itw4xxfn84b">
              <X className="w-5 h-5 text-slate-500 mr-2" data-id="element-876" data-mp="1e9ywy3cje6g8" />
              HIRE Edge is not:
            </h3>
            <ul className="space-y-4" data-id="element-877" data-mp="19i77xx9148s7">
              {['A hiring or onboarding solution', 'A training or retention program', 'A replacement for internal leadership'].map((item, idx) => <li key={idx} className="text-slate-400 flex items-start" data-id="element-878" data-mp="gryu2hlj0ajf" data-mpi={idx}>
                  <span className="w-1.5 h-1.5 rounded-full bg-slate-600 mr-3 mt-2" data-id="element-879" data-mp="2sftyydlp3qou" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </section>

      {/* 3. OWNERSHIP MAP */}
      <section className="py-20 px-6 md:px-12 bg-slate-900/20 border-y border-slate-800" data-id="element-880" data-mp="2oft81thetn0w">
        <div className="max-w-6xl mx-auto" data-id="element-881" data-mp="2odfexq6aikvz">
          <h2 className="text-3xl font-bold text-white mb-12 text-center" data-id="element-882" data-mp="3c549zeahxngm">
            Ownership Map
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16" data-id="element-883" data-mp="3g5ockxdu9ja5">
            {/* HIRE Owns */}
            <div className="bg-slate-900/40 border border-slate-700 rounded-xl p-8 relative overflow-hidden" data-id="element-884" data-mp="326ok1en7gk8p">
              <div className="absolute top-0 left-0 w-full h-1 bg-slate-600" data-id="element-885" data-mp="374geogf8ikgl" />
              <h3 className="text-xl font-bold text-white mb-8 flex items-center" data-id="element-886" data-mp="1qr9rcn214eje">
                <span className="w-2 h-2 rounded-full bg-slate-600 mr-3" data-id="element-887" data-mp="1vs5rcpj9fgjj" />
                HIRE Owns
              </h3>
              <ul className="space-y-4" data-id="element-888" data-mp="2b2c8a0qbp1n9">
                {['Job boards and recruiting traffic', 'Screening and pre-qualification', 'Multi-market coordination', 'Reporting and visibility'].map((item, idx) => <li key={idx} className="flex items-start text-slate-300" data-id="element-889" data-mp="1xaxovssi6yfo" data-mpi={idx}>
                    <Check className="w-5 h-5 text-slate-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-890" data-mp="2tylvbdj7d2je" />
                    <span data-id="element-891" data-mp="2pxs70j1ullpz">{item}</span>
                  </li>)}
              </ul>
            </div>

            {/* You Own */}
            <div className="bg-slate-900/40 border border-slate-700 rounded-xl p-8 relative overflow-hidden" data-id="element-892" data-mp="2l11rbwtygs53">
              <div className="absolute top-0 left-0 w-full h-1 bg-[#7FE0C3]" data-id="element-893" data-mp="2g28bhxr74p1r" />
              <h3 className="text-xl font-bold text-white mb-8 flex items-center" data-id="element-894" data-mp="19l3bna49v7uw">
                <span className="w-2 h-2 rounded-full bg-[#7FE0C3] mr-3" data-id="element-895" data-mp="14jxk3fmclqmy" />
                You Own
              </h3>
              <ul className="space-y-4" data-id="element-896" data-mp="uildhy16xvgo">
                {['Interviews and hiring decisions', 'Onboarding and training', 'Retention and performance'].map((item, idx) => <li key={idx} className="flex items-start text-slate-300" data-id="element-897" data-mp="1966hrv9sy0q6" data-mpi={idx}>
                    <Check className="w-5 h-5 text-[#7FE0C3] mr-3 mt-0.5 flex-shrink-0" data-id="element-898" data-mp="1d79xmhrunwre" />
                    <span data-id="element-899" data-mp="1d9mawhmnxiy4">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="mt-8 text-center" data-id="element-900" data-mp="1n4wg1e8cy6g4">
            <p className="text-slate-400" data-id="element-901" data-mp="1n67hh7ebz242">
              Edge works best when your internal team already knows how to hire
              and onboard effectively.
            </p>
          </div>
        </div>
      </section>

      {/* 4. HOW EDGE FITS INTO THE SYSTEM */}
      <section className="py-20 px-6 md:px-12 max-w-4xl mx-auto" data-id="element-902" data-mp="3twx6i9fsc2z0">
        <div className="bg-slate-900/30 border border-slate-800 rounded-xl p-8 md:p-12 text-center" data-id="element-903" data-mp="3lv7mtmnq5ids">
          <h2 className="text-2xl font-bold text-white mb-6" data-id="element-904" data-mp="3gwcwlznfgrjn">
            How Edge Fits Into The System
          </h2>
          <p className="text-slate-300 mb-6 leading-relaxed" data-id="element-905" data-mp="3vtnhu0pvhbsk">
            All HIRE partners use the same 10-step recruiting system. Edge
            focuses on the infrastructure stages so your team can handle
            execution.
          </p>
          <div className="flex flex-wrap justify-center gap-3 text-sm" data-id="element-906" data-mp="8ml4ost81eov">
            {['Attract', 'Engage', 'Screen', 'Qualify'].map((step, idx) => <span key={idx} className="px-4 py-2 bg-slate-800 border border-slate-700 rounded-full text-slate-400" data-id="element-907" data-mp="iequpwzwxm1f" data-mpi={idx}>
                {step}
              </span>)}
            <span className="px-4 py-2 text-slate-600" data-id="element-908" data-mp="rfyu6ie60sx3">→</span>
            {['Interview', 'Commit', 'Onboard', 'Integrate', 'Train', 'Launch', 'Retain'].map((step, idx) => <span key={idx} className="px-4 py-2 bg-slate-900 border border-slate-800 rounded-full text-slate-500" data-id="element-909" data-mp="1azwb2ilqr63o" data-mpi={idx}>
                {step}
              </span>)}
          </div>
          <p className="text-xs text-slate-500 mt-6" data-id="element-910" data-mp="122dkyzt8q1kx">
            Infrastructure stages (highlighted) vs. execution stages
          </p>
        </div>
      </section>

      {/* 5. LMS + SUPPORT */}
      <section className="py-20 px-6 md:px-12 max-w-4xl mx-auto" data-id="element-911" data-mp="s468ou9wc7p9">
        <div className="flex items-start space-x-6 bg-slate-900/30 border border-slate-800 rounded-xl p-8" data-id="element-912" data-mp="ebzq71j9tomn">
          <div className="w-12 h-12 rounded-lg bg-slate-800 flex items-center justify-center flex-shrink-0" data-id="element-913" data-mp="icte3uwpr3fj">
            <BookOpen className="w-6 h-6 text-slate-400" data-id="element-914" data-mp="4daig1l39kk4" />
          </div>
          <div data-id="element-915" data-mp="9ak89ice3y8h">
            <h3 className="text-xl font-bold text-white mb-4" data-id="element-916" data-mp="9b2cp297hirh">
              Learning Management System Access
            </h3>
            <p className="text-slate-300 mb-4 leading-relaxed" data-id="element-917" data-mp="or8yv80vp4ej">
              All Edge partners receive access to HIRE's Learning Management
              System covering recruiting and hiring best practices.
            </p>
            <ul className="space-y-2 text-slate-400 text-sm" data-id="element-918" data-mp="auddcg3fxkhl">
              <li className="flex items-start" data-id="element-919" data-mp="avy6q2e0qxdv">
                <span className="w-1.5 h-1.5 rounded-full bg-slate-600 mr-2 mt-1.5" data-id="element-920" data-mp="5v0q3u8nqbeh" />
                DIY reference library
              </li>
              <li className="flex items-start" data-id="element-921" data-mp="12pommy9qhjt">
                <span className="w-1.5 h-1.5 rounded-full bg-slate-600 mr-2 mt-1.5" data-id="element-922" data-mp="3s9ttpcaurtpl" />
                Optional support and guidance
              </li>
              <li className="flex items-start" data-id="element-923" data-mp="3oal0c8jq5xuk">
                <span className="w-1.5 h-1.5 rounded-full bg-slate-600 mr-2 mt-1.5" data-id="element-924" data-mp="3ja6wl2p5pa2c" />
                Not a replacement for internal execution
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* 7. WHO EDGE IS FOR */}
      <section className="py-20 px-6 md:px-12 bg-slate-900/20 border-y border-slate-800" data-id="element-925" data-mp="1tumbww2zzhwg">
        <div className="max-w-5xl mx-auto" data-id="element-926" data-mp="1yprzs0fyn6n6">
          <h2 className="text-3xl font-bold text-white mb-12 text-center" data-id="element-927" data-mp="23q687jlh4ilq">
            Who Edge Is For
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-928" data-mp="27r9m40jyo4kb">
            <div data-id="element-929" data-mp="1b2ad2jbjyyr2">
              <h3 className="text-lg font-bold text-white mb-6 flex items-center" data-id="element-930" data-mp="1b2tjp3vr60ps">
                <Check className="w-5 h-5 text-[#7FE0C3] mr-2" data-id="element-931" data-mp="1g0vcigizdeeg" />
                Edge is a good fit if you:
              </h3>
              <ul className="space-y-4" data-id="element-932" data-mp="1k1nohhj8lxef">
                {['Already have strong onboarding and training', 'Want better candidate quality and predictability', 'Prefer to keep hiring decisions internal', 'Want a lower-commitment entry point'].map((item, idx) => <li key={idx} className="text-slate-400 flex items-start" data-id="element-933" data-mp="3vk3teta7h2ms" data-mpi={idx}>
                    <span className="w-1.5 h-1.5 rounded-full bg-[#7FE0C3] mr-3 mt-2" data-id="element-934" data-mp="3vjtycrab05a8" />
                    {item}
                  </li>)}
              </ul>
            </div>
            <div data-id="element-935" data-mp="8g75d0m6o7et">
              <h3 className="text-lg font-bold text-white mb-6 flex items-center" data-id="element-936" data-mp="8dkyl3749vxn">
                <X className="w-5 h-5 text-slate-500 mr-2" data-id="element-937" data-mp="ddpfuvfumuox" />
                Edge is not a good fit if you:
              </h3>
              <ul className="space-y-4" data-id="element-938" data-mp="3gv7ce6q68fa1">
                {['Want help fixing retention', 'Want hiring standards designed for you', 'Want recruiting execution handled externally'].map((item, idx) => <li key={idx} className="text-slate-400 flex items-start" data-id="element-939" data-mp="3qmbtpd3bkc81" data-mpi={idx}>
                    <span className="w-1.5 h-1.5 rounded-full bg-slate-600 mr-3 mt-2" data-id="element-940" data-mp="2t4v42ur0kgix" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* 8. UPGRADE PATH */}
      <section className="py-20 px-6 md:px-12 max-w-4xl mx-auto" data-id="element-941" data-mp="2lllylclmp1z5">
        <div className="flex items-start space-x-6 bg-slate-900/30 border border-slate-800 rounded-xl p-8" data-id="element-942" data-mp="2lkatn9gg5o6g">
          <div className="w-12 h-12 rounded-lg bg-slate-800 flex items-center justify-center flex-shrink-0" data-id="element-943" data-mp="2clfo7zl88i47">
            <TrendingUp className="w-6 h-6 text-slate-400" data-id="element-944" data-mp="27m2qgjsthqmu" />
          </div>
          <div data-id="element-945" data-mp="27ofdvchcgt7a">
            <h3 className="text-xl font-bold text-white mb-4" data-id="element-946" data-mp="22vmdt1wtm91j">
              Natural Progression
            </h3>
            <p className="text-slate-300 leading-relaxed" data-id="element-947" data-mp="1xvzymmxfmiq3">
              Many Edge partners later move into Advantage when they want system
              ownership and accountability — without changing platforms or
              starting over.
            </p>
          </div>
        </div>
      </section>

      {/* 9. CTA */}
      <section className="py-32 px-6 md:px-12 text-center border-t border-slate-800/50" data-id="element-948" data-mp="1jxtc22xxo55q">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-8" data-id="element-949" data-mp="1a8wb3dyu0cci">
          See if HIRE Edge fits your hiring model.
        </h2>
        <button className="inline-flex items-center px-8 py-4 bg-slate-700 hover:bg-slate-600 text-white font-bold rounded-lg transition-all" data-id="element-950" data-mp="1ec2iioxok9kk">
          Learn More
          <ArrowRight className="ml-2 w-5 h-5" data-id="element-951" data-mp="15b4c5zzrrpyt" />
        </button>
      </section>
    </div>;
}